import React from "react";
import AIChatPanel from "../../core/ai/components/AIChatPanel";

export default function AIChat() {
  return <AIChatPanel fullScreen={false} />;
}
